import { Button, IconStarRateFill, Text, XStack, tokens } from '@fhs/ui';
import { actions, useAppDispatch } from '@fhs-legacy/frontend/src/state/global-state';
import { useLoyaltyUser } from '@fhs-legacy/frontend/src/state/loyalty/hooks/use-loyalty-user';
import { HapticsNotificationType, hapticNotification } from '@fhs-legacy/frontend/src/utils/haptic';
import { REWARD_AVAILABLE } from '@fhs-legacy/frontend/src/utils/test-ids';

import { IRewardBarComponentProps, styles } from './typesAndStyles';

export default function RewardAvailable({
  cartId,
  loyaltyRewardAvailable,
}: IRewardBarComponentProps) {
  const dispatch = useAppDispatch();
  const { loyaltyUser } = useLoyaltyUser();

  const handleAddReward = () => {
    const { applyReward, setIsPricingRewardApplication } = actions.loyalty;
    dispatch(setIsPricingRewardApplication(true));

    dispatch(
      applyReward({
        cartId,
        rewardBenefitId: loyaltyRewardAvailable.rewardBenefitId,
        loyaltyUser,
      })
    );
    hapticNotification({ type: HapticsNotificationType.SUCCESS });
  };

  return (
    <XStack testID={REWARD_AVAILABLE} style={styles.redeemContainer}>
      <Text.Ui size="sm" style={{ flex: 1 }}>
        Redeem as a Reward:
      </Text.Ui>

      <Button size="xs" type="outline" style={styles.pointsButton} onPress={handleAddReward}>
        <Button.Icon color={tokens.colors.$houseYellow}>
          <IconStarRateFill />
        </Button.Icon>

        <Button.Text style={styles.pointsButtonText}>
          Use {loyaltyRewardAvailable.pointCost}
        </Button.Text>
      </Button>
    </XStack>
  );
}
